<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                                             :table-items="tableItems"
                                             @load-items="getTableData"
                                             @row-click="clickToRowItem"
                                             ref="gofixTable">
                            <template slot="gofix_table:name" slot-scope="row">
                                {{row.item.name ? row.item.name : 'Cron System'  }}
                            </template>
                            <template slot="gofix_table:import_logs.created_at" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:data" slot-scope="row">
                                <div class="d-flex table-import-log-status" v-if="row.item.data && row.item.data.count">
                                    <p class="mb-0 mr-2 d-flex align-items-center">
                                        <span class="mr-2 icon-dot icon-dot-succeeded"></span>
                                        <span>{{row.item.data.count.succeeded}} succeeded</span>
                                    </p>
                                    <p class="mb-0 mr-2 d-flex align-items-center">
                                        <span class="mr-2 icon-dot icon-dot-warning"></span>
                                        <span>{{row.item.data.count.warning}} warning</span>
                                    </p>
                                    <p class="mb-0 d-flex align-items-center">
                                        <span class="mr-2 icon-dot icon-dot-failed"></span>
                                        <span>{{row.item.data.count.failed}} failed</span>
                                    </p>
                                </div>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>

            <b-modal :no-close-on-backdrop="true"
                     modal-class="modal-create modal-import-logs"
                     title="Detail Log"
                     hide-footer :centered="true"
                     v-model="modals.detail.open">
                <div class="importLogDetail" v-if="modals.detail.data">
                    <ul>
                        <li class="text-bold">
                            <span class="line">Line 1:</span>
                            <span class="desc">This is column name</span>
                        </li>
                        <li v-for="log in modals.detail.data.data.log" v-bind:class="{warning:log.status === 'warning',failed:log.status === 'failed' ,succeeded:log.status === 'succeeded' }" class="d-flex">
                            <span class="line">Line {{log.line}}:</span>
                            <span class="desc" v-html="log.desc ? log.desc : ''"></span>
                        </li>
                    </ul>
                </div>
                <div class="pt-3 pb-3">
                    <b-button-group class="text-right d-block pr-3">
                        <gofix-button label="CLOSE" @click="modals.detail.open = false" noBorder dark></gofix-button>
                    </b-button-group>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';
    import JsonViewer from 'vue-json-viewer';

    export default {
        name: 'import-logs',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['import_logs']));
            return {
                tableConfig:{
                    name: 'account-import-logs',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport:false,
                        tableExport:false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "created_at",
                    sortDirection: "desc",
                },
                tableItems: [],
                modals:{
                    detail: {
                        open: false,
                        loading: false,
                        data: null,
                    }
                }
            }
        },
        components: {JsonViewer},
        created () {

        },

        methods:{
            /*-- Table callback --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("ImportLogController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the import log", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                this.modals.detail.open = true;
                this.modals.detail.data = item;
            },
            /*---------------*/
        }
    }
</script>
